import { useEffect } from 'react';
import type { User } from 'services/FirebaseService/auth';
import { initializeIntercom, shutdownIntercom } from '../libs/intercom';
import { Flags, useFlag } from '../libs/launch-darkly';

export function useIntercom(user: User | null) {
  const intercomEnabled = useFlag(Flags.intercomEnabled);
  useEffect(() => {
    if (!intercomEnabled || !user) {
      shutdownIntercom();
      return;
    }

    initializeIntercom(user);
  }, [user, intercomEnabled]);
}
